export default {"src":"/_next/static/media/default_3.32a87719.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};